// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"ToolbarHeader__Toolbar__1W58m","Logo":"ToolbarHeader__Logo__1MgGy"};